export const breakPoints = {
  mobile: 768,
  tablet: 1099,
  desktop: 1440,
};

export const API_KEY = '9rNbG1XrdZT5jXuY1Geolwtt';
